<template>
  <div>
    <div class="sub-title my-3">포트폴리오 평가</div>
    <div>
      <div v-for="(p, px) in portfolios" :key="px">
      {{portfolios.name}}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  components: {},
  name: 'StudentPortfolioTest',
  props: ['training'],
  data: () => ({
    portfolios: []
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('subject', ['subjects']),
    ...mapGetters('auth', ['failScore'])
  },
  methods: {
    async load () {
      // 폴트 폴리오 과목을 찾아라.... 어디에 있는가?
      // lecture의 portfoliod에
      if (!this.subjects) return
      Object.keys(this.subjects.NONNCS).forEach(s => {
        // s.lectures.filter(l => l.portfolio).forEach(l => this.portfolios.push(l))
      })
      // Object.keys(this.subjects.NONNCS).forEach(s => {
      //   s.lectures.filter(l => l.portfolio).forEach(l => this.portfolios.push(l))
      // })
    },
    isRetry (code) {
      return true
    }
  },
  created () {
    this.load()
  },
  watch: {
    subjects: 'load'
  }
}
</script>
